import { motion } from "framer-motion";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const PAD = 12;

export function balloonPos(rect, vw, vh) {
  const width = Math.min(360, vw - PAD * 2);
  if (!rect) return { width, left: (vw - width) / 2, top: Math.max(PAD, vh / 2 - 130) };
  if (vw < 640) return { width, left: PAD, ...(rect.top + rect.height / 2 < vh / 2 ? { bottom: PAD + 4 } : { top: PAD + 4 }) };
  const left = Math.min(Math.max(PAD, rect.left), vw - width - PAD);
  if (rect.height > vh * 0.55) return { width, left: vw - width - PAD * 2, bottom: PAD * 2 };
  if (vh - rect.bottom > 250) return { width, left, top: rect.bottom + 16 };
  if (rect.top > 250) return { width, left, bottom: vh - rect.top + 16 };
  return { width, left: vw - width - PAD * 2, bottom: PAD * 2 };
}

export function TourBalloon({ step, text, index, total, pos, onNext, onBack, onSkip, onRestart }) {
  const last = index === total - 1;
  return (
    <motion.div role="dialog" aria-label={step.title} style={pos} initial={{ opacity: 0, y: 10, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.97 }} transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      // o balão fica fora das janelas (Dialog) da tela: sem isto, clicar em "Próximo" fecharia a janela que o guia está mostrando
      onPointerDown={(e) => e.stopPropagation()}
      className="pointer-events-auto absolute rounded-2xl border bg-card p-5 text-foreground shadow-2xl" data-testid="tour-balloon">
      <div className="flex items-center justify-between gap-2">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-primary" data-testid="tour-step-count">Passo {index + 1} de {total}</span>
        <button type="button" onClick={onSkip} aria-label="Fechar tour" className="rounded-md p-1 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground" data-testid="tour-close-btn"><X className="h-4 w-4" /></button>
      </div>
      <div className="mt-2 h-1 overflow-hidden rounded-full bg-muted">
        <motion.div className="h-full rounded-full bg-primary" initial={false} animate={{ width: `${((index + 1) / total) * 100}%` }} transition={{ duration: 0.35 }} />
      </div>
      <h3 className="mt-4 font-display text-lg font-semibold leading-snug" data-testid="tour-step-title">{step.title}</h3>
      <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground" data-testid="tour-step-text">{text}</p>
      <div className="mt-5 flex items-center justify-between gap-2">
        <Button variant="ghost" size="sm" onClick={onSkip} data-testid="tour-skip-btn">{step.guia ? "Fechar guia" : "Pular tour"}</Button>
        <div className="flex gap-2">
          {index > 0 && !step.guia && <Button variant="outline" size="sm" onClick={onBack} data-testid="tour-back-btn">Voltar</Button>}
          {index > 0 && step.guia && onRestart && <Button variant="outline" size="sm" onClick={onRestart} data-testid="tour-restart-btn">Recomeçar</Button>}
          <Button size="sm" onClick={onNext} autoFocus={!step.guia} data-testid="tour-next-btn">{last ? "Concluir" : "Próximo"}</Button>
        </div>
      </div>
    </motion.div>
  );
}
